
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.121 3.488c-3.902-3.9-10.247-3.9-14.15 0-3.9 3.901-3.9 10.249 0 14.15a9.976 9.976 0 007.076 2.924 9.974 9.974 0 007.074-2.924c3.901-3.901 3.901-10.249 0-14.15zm-2.948 10.023a.833.833 0 11-1.179 1.179l-2.947-2.948L7.1 14.689a.835.835 0 01-1.179-1.18l2.947-2.946L5.92 7.615a.833.833 0 111.178-1.179l2.948 2.948 2.947-2.948a.833.833 0 111.179 1.18l-2.947 2.947 2.947 2.948z","fill":"#2F2F34"}})])
          )
        }
      }
    